
import React, { cloneElement } from "react";
import { Route } from "react-router-dom";
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import PropTypes from 'prop-types';

const SafeRoute = ({ component: Component, children = null, ...props }) => (
  <Route {...props} render={(routeProps) => {
    const newProps = { ...routeProps, ...props };

    return <ErrorBoundary>
      {Component ? <Component {...newProps} /> : cloneElement(children, { ...newProps })}
    </ErrorBoundary>;
  }
  } />
);

SafeRoute.propTypes = {
  component: PropTypes.any,
  children: PropTypes.any
};

export default SafeRoute;